import { createClient } from 'contentful';

const client = createClient({
  space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
});

export async function getHelpSections() {
  const entries = await client.getEntries({
    content_type: 'helpSection',
    order: 'fields.order',
  });
  return entries.items.map(item => ({
    id: item.sys.id,
    ...item.fields,
  }));
}

export async function getHelpSubSections(sectionId) {
  const entries = await client.getEntries({
    content_type: 'helpSubSection',
    'fields.section.sys.id': sectionId,
    order: 'fields.order',
  });
  return entries.items.map(item => ({
    id: item.sys.id,
    ...item.fields,
  }));
}

export async function getHelpArticles(subSectionId) {
  const entries = await client.getEntries({
    content_type: 'helpArticle',
    'fields.subSection.sys.id': subSectionId,
    order: 'fields.order',
  });
  return entries.items.map(item => ({
    id: item.sys.id,
    ...item.fields,
  }));
}

export async function getHelpArticlesDirect(sectionId) {
  const entries = await client.getEntries({
    content_type: 'helpArticle',
    'fields.section.sys.id': sectionId,
    order: 'fields.order',
  });
  return entries.items.map(item => ({
    id: item.sys.id,
    ...item.fields,
  }));
}

export async function getAllHelpContent() {
  const [sectionsRes, subSectionsRes, articlesRes] = await Promise.all([
    client.getEntries({ content_type: 'helpSection', order: 'fields.order' }),
    client.getEntries({ content_type: 'helpSubSection', order: 'fields.order' }),
    client.getEntries({ content_type: 'helpArticle', order: 'fields.order' }),
  ]);

  const articles = articlesRes.items.map(item => ({
    id: item.sys.id,
    ...item.fields,
    sectionId: item.fields.section?.sys?.id,
    subSectionId: item.fields.subSection?.sys?.id,
  }));

  const subSections = subSectionsRes.items.map(item => ({
    id: item.sys.id,
    ...item.fields,
    sectionId: item.fields.section?.sys?.id,
    articles: articles.filter(a => a.subSectionId === item.sys.id),
  }));

  const sections = sectionsRes.items.map(item => ({
    id: item.sys.id,
    ...item.fields,
    subSections: subSections.filter(ss => ss.sectionId === item.sys.id),
    directArticles: articles.filter(a => a.sectionId === item.sys.id && !a.subSectionId),
  }));

  return sections;
}

export async function getAllFaqContent() {
  const [categoriesRes, itemsRes] = await Promise.all([
    client.getEntries({ content_type: 'faqCategory', order: 'fields.order' }),
    client.getEntries({ content_type: 'faqItem', order: 'fields.order' }),
  ]);

  const items = itemsRes.items.map(item => ({
    id: item.sys.id,
    ...item.fields,
    categoryId: item.fields.category?.sys?.id,
  }));

  const categories = categoriesRes.items.map(item => ({
    id: item.sys.id,
    ...item.fields,
    items: items.filter(i => i.categoryId === item.sys.id),
  }));

  return categories;
}

export async function getHelpSettings() {
  const entries = await client.getEntries({ content_type: 'helpSettings', limit: 1 });
  const entry = entries.items[0];
  return entry ? { id: entry.sys.id, ...entry.fields } : null;
}
